import { mapMutations, mapActions, mapState } from 'vuex'
import xss from 'xss'
import { buyStatus } from '@/defines'
import types from '@/views/CourseDetail/store/types'
import DifficultRecommend from '@/components/DifficultRecommend'
export default {
  data() {
    return {
      xss,
      openReminder: false
    }
  },
  components: {
    DifficultRecommend
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin,
      courseDetail: state => state.CourseDetail.courseDetail,
      incPurchase: state => state.CourseDetail.incPurchase, // 加价购
      courseRecommend: state => state.CourseDetail.courseRecommend,
      presaleStatus: state => state.CourseDetail.presaleStatus,
      showGradingQuestion: state => state.showGradingQuestion,
      dataLoading: state => state.CourseDetail.dataLoading,
      showGradingResult: state => state.showGradingResult,
      // 需要改成课程标准化后的
      // liveLongTermSift: state => state.CourseCenter.liveLongTermSift
      courseSift: state => state.CourseCenter.courseSift
    }),
    // 按钮不是立即购买、诊断后报名、无资格报名、付定金、提前诊断的置灰
    isDisabled() {
      return !(
        this.courseDetail.saleStatus.id === buyStatus.immediatelyBuy ||
        this.courseDetail.saleStatus.id === buyStatus.diagnose ||
        Number(this.courseDetail.saleStatus.id) === buyStatus.payDeposit ||
        Number(this.courseDetail.saleStatus.id) === buyStatus.earlyDiagnose ||
        Number(this.courseDetail.saleStatus.id) === buyStatus.diagnoseReport
      )
    },
    chineseTeacherList() {
      if (
        this.courseDetail.chineseTeacher &&
        this.courseDetail.chineseTeacher.length > 0
      ) {
        return this.courseDetail.chineseTeacher.map(item => {
          return {
            id: item.id,
            title: item.typeName,
            name: item.name,
            url: item.spell,
            avatar: item.avatars[0],
            description: item.description,
            teacher_type: item.teacher_type
          }
        })
      }
      return []
    },
    foreignTeacherList() {
      if (
        this.courseDetail.foreignTeacher &&
        this.courseDetail.foreignTeacher.length > 0
      ) {
        return this.courseDetail.foreignTeacher.map(item => {
          return {
            id: item.id,
            title: item.typeName,
            name: item.name,
            url: item.spell,
            avatar: item.avatars[0],
            description: item.description,
            teacher_type: item.teacher_type
          }
        })
      }
      return []
    }
  },
  methods: {
    handleClose() {
      this.openReminder = false
    },
    ...mapActions({
      getGiftCard: types.GET_GIFT_CARD,
      getPreSaleStatus: types.GET_PRESALE_STATUS,
      getCartCount: types.GET_CART_COUNT
    }),
    ...mapMutations({
      setLoaded: types.SET_IS_LOADED,
      setShowDifficultGuide: 'SET_SHOWDIFFICULTGUIDE'
    }),
    updataDifficultyId(val, event) {
      const dataMap = {}
      const difficulties = this.courseSift.difficulties
      for (let i = 0; i < difficulties.length; i++) {
        const item = difficulties[i]
        dataMap[item.id] = item
      }
      const notEmpty = this.notEmptyCheck(dataMap)
      if (notEmpty && !dataMap.hasOwnProperty(val)) {
        this.controler({ id: '0', type: 'difficultyId', index: 1 }, event)
        return
      }
      this.controler({ id: val, type: 'difficultyId' }, event)
    },
    scanReport(event) {
      this.xesLog(
        'click',
        { type: 'xeslog-scanReport', clickId: '1.3.36', courseid: this.courseDetail.id },
        { target: event.target }
      )
      window.open(this.courseDetail.examPath)
    },
    xesLog(eventName, params, event) {
      const XESLog = new this.$XESLog({
        gradeid: this.courseDetail.grades
          ? this.courseDetail.grades
              .filter(item => item)
              .map(item => item.id)
              .join(',')
          : '',
        coursetype: this.courseDetail.coursetype,
        courseid: this.courseDetail.id,
        classid: this.courseDetail.class.id,
        recommendcount: Number(this.courseRecommend.count) || '',
        subjectid: this.courseDetail.subjects[0] ? this.courseDetail.subjects[0].id : '',
        category: this.courseDetail.category,
        ...params
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/CourseDetail/mixins/methods.js